export class RbacPermissionsConstant {
  /**
   * Pages
   */
  public static PAGES_SINGLE_OFFER = 'Pages\\Single\\Offer';
  public static PAGES_SINGLE_GOAL = 'Pages\\Single\\Goal';
  public static PAGES_SINGLE_TARGET = 'Pages\\Single\\Target';
  public static PAGES_SINGLE_CLICK = 'Pages\\Single\\Click';
  public static PAGES_SINGLE_AFFILIATE = 'Pages\\Single\\Affiliate';
  public static PAGES_SINGLE_AFFILIATES_TRACKER = 'Pages\\Single\\AffiliatesTracker';

  public static PAGES_SPECIAL_DASHBOARD = 'Pages\\Special\\Dashboard';
  public static PAGES_SPECIAL_REPORT_BUILDER = 'Pages\\Special\\AffiliateCrm\\ReportBuilder';
  public static PAGES_SPECIAL_COMPARING_ANALYTICS = 'Pages\\Special\\AffiliateCrm\\ComparingAnalytics';
  public static PAGES_SPECIAL_CRM_SETTINGS = 'Pages\\Special\\CrmSettings';
  public static PAGES_SPECIAL_ALLOW_SENSITIVE_DATA_VIEW = 'Pages\\Special\\AffiliateCrm\\AllowSensitiveDataView';

  public static PAGES_TABLE_OFFERS = 'Pages\\Table\\AffiliateCrm\\Offers';
  public static PAGES_TABLE_GOALS = 'Pages\\Table\\Goals';
  public static PAGES_TABLE_TARGETS = 'Pages\\Table\\AffiliateCrm\\Targets';
  public static PAGES_TABLE_CLICKS = 'Pages\\Table\\AffiliateCrm\\Clicks';
  public static PAGES_TABLE_AFFILIATES = 'Pages\\Table\\AffiliateCrm\\Affiliates';
  public static PAGES_TABLE_AFFILIATES_TRACKERS = 'Pages\\Table\\AffiliateCrm\\AffiliatesTrackers';
  public static PAGES_TABLE_TRACKING_DOMAINS = 'Pages\\Table\\TrackingDomains';
  public static PAGES_TABLE_CRM_ACCOUNTS = 'Pages\\Table\\Users';
  public static PAGES_TABLE_TOKENS = 'Pages\\Table\\Tokens';
  public static PAGES_TABLE_ROLES = 'Pages\\Table\\Roles';
  public static PAGES_TABLE_SMART_LINKS = 'Pages\\Table\\AffiliateCrm\\SmartLinks';
  public static PAGES_TABLE_INVOICES = 'Pages\\Table\\AffiliateCrm\\Invoices';
  public static PAGES_TABLE_PAYMENTS = 'Pages\\Table\\AffiliateCrm\\Payments';
  public static PAGES_TABLE_EARNINGS = 'Pages\\Table\\AffiliateCrm\\Earnings';
  public static PAGES_TABLE_CONVERSIONS = 'Pages\\Table\\AffiliateCrm\\ConversionsTable';
  public static PAGES_TABLE_GLOBAL_POSTBACK = 'Pages\\Table\\AffiliateCrm\\GlobalPostback';
  public static PAGES_TABLE_AFFILIATES_AREA_TABLE = 'Pages\\Table\\AffiliateCrm\\AffiliatesAffAreaTable';
  public static PAGES_TABLE_AFFILIATE_PAYMENT_METHODS = 'Pages\\Table\\AffiliateCrm\\AffiliatePaymentMethods';

  /**
   * Widgets
   */

  public static WIDGETS_SIDEBAR_WELCOME = 'NewWidgets\\AffiliateCrm\\Dashboard\\WelcomePermission';
  public static WIDGETS_DASHBOARD_CLICKS_CONVERSIONS = 'NewWidgets\\AffiliateCrm\\Dashboard\\ClicksConversionsChartPermission';
  public static WIDGETS_DASHBOARD_STATISTIC = 'NewWidgets\\AffiliateCrm\\Dashboard\\StatisticPermission';
  public static WIDGETS_OFFER_AFFILIATE_ACCESS = 'NewWidgets\\AffiliateCrm\\Offer\\AffiliateAccessPermission';
  public static WIDGETS_OFFER_TRACKERS_LIST = 'NewWidgets\\AffiliateCrm\\Offer\\AffiliateTrackersListPermission';
  public static WIDGETS_OFFER_TRACKING_DOMAINS = 'NewWidgets\\AffiliateCrm\\Offer\\AffiliateTrackingDomainsPermission';
  public static WIDGETS_OFFER_CLICKS_LIST = 'NewWidgets\\AffiliateCrm\\Offer\\ClicksListPermission';
  public static WIDGETS_OFFER_GOALS_LIST = 'NewWidgets\\AffiliateCrm\\Offer\\GoalsListPermission';
  public static WIDGETS_OFFER_LINK_GENERATOR = 'NewWidgets\\AffiliateCrm\\Offer\\LinkGeneratorPermission';
  public static WIDGETS_OFFER_URLS_LIST = 'NewWidgets\\AffiliateCrm\\Offer\\OfferUrlsListPermission';
  public static WIDGETS_OFFER_PIXEL_GENERATOR = 'NewWidgets\\AffiliateCrm\\Offer\\PixelGeneratorPermission';
  public static WIDGETS_OFFER_PROFILE = 'NewWidgets\\AffiliateCrm\\Offer\\ProfilePermission';
  public static WIDGETS_OFFER_SHORT_URLS = 'NewWidgets\\AffiliateCrm\\Offer\\ShortUrlsPermission';
  public static WIDGETS_OFFER_TARGETS_LIST = 'NewWidgets\\AffiliateCrm\\Offer\\TargetsListPermission';
  public static WIDGETS_OFFER_AFFILIATE_GOALS_LIST = 'NewWidgets\\AffiliateCrm\\Offer\\AffiliateGoalPermission';

  // public static WIDGETS_OFFER_URL_SHORTENER_LIST = 'NewWidgets\\UrlShortener\\RegistryPermission';

  public static WIDGETS_GOAL_PROFILE = 'NewWidgets\\AffiliateCrm\\Goal\\ProfilePermission';
  public static WIDGETS_TARGET_PROFILE = 'NewWidgets\\AffiliateCrm\\Target\\ProfilePermission';
  public static WIDGETS_CLICK_PROFILE = 'NewWidgets\\AffiliateCrm\\Click\\ProfilePermission';
  public static WIDGETS_AFFILIATE_PROFILE = 'NewWidgets\\AffiliateCrm\\Affiliate\\ProfilePermission';
  public static WIDGETS_AFFILIATE_TRACKERS_PROFILE = 'NewWidgets\\AffiliateCrm\\AffiliateTrackers\\ProfilePermission';
  public static WIDGETS_ADVERTISER_PROFILE = 'NewWidgets\\AffiliateCrm\\Advertiser\\ProfilePermission';
  public static WIDGETS_CRM_ACCOUNT_PROFILE = 'NewWidgets\\AffiliateCrm\\User\\ProfilePermission';
  public static WIDGETS_TRACKING_DOMAIN_PROFILE = 'NewWidgets\\AffiliateCrm\\TrackingDomain\\ProfilePermission';
  public static WIDGETS_TRACKING_TOKEN_PROFILE = 'NewWidgets\\AffiliateCrm\\Token\\ProfilePermission';
  public static WIDGETS_SMART_LINK_PROFILE = 'NewWidgets\\AffiliateCrm\\SmartLink\\ProfilePermission';

  /**
   * Commands
   */

  public static COMMANDS_GOAL_CREATE_EDIT = 'NewCommands\\Goal\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_OFFER_TRACKING_DOMAIN_CREATE_EDIT = 'NewCommands\\AffiliateOfferTrackingDomain\\CreateEditPermission';
  public static COMMANDS_OFFER_CREATE_EDIT = 'NewCommands\\Offer\\CreateEditPermission';
  public static COMMANDS_OFFER_URL_CREATE_EDIT = 'NewCommands\\OfferUrl\\CreateEditPermission';
  public static COMMANDS_TARGET_CREATE_EDIT = 'NewCommands\\Target\\CreateEditPermission';
  public static COMMANDS_URL_SHORTENER_CREATE = 'NewCommands\\UrlShortener\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_CREATE_EDIT = 'NewCommands\\Affiliate\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_TRACKER_CREATE_EDIT = 'NewCommands\\AffiliateCrm\\AffiliateTracker\\CreateEditPermission';
  public static COMMANDS_ADVERTISER_CREATE_EDIT = 'NewCommands\\Advertiser\\CreateEditPermission';
  public static COMMANDS_TRACKING_DOMAIN_CREATE_EDIT = 'NewCommands\\TrackingDomain\\CreateEditPermission';
  public static COMMANDS_CRM_ACCOUNT_CREATE_EDIT = 'NewCommands\\User\\CreateEditPermission';
  public static COMMANDS_TOKEN_CREATE_EDIT = 'NewCommands\\Token\\CreateEditPermission';
  public static COMMANDS_GLOBAL_POSTBACK_CREATE_EDIT = 'NewCommands\\AffiliateCrm\\GlobalPostback\\CreateEditPermission';
  public static COMMANDS_TABLE_CREATE_EDIT_FINANCE = 'NewCommands\\AffiliateCrm\\Invoice\\CreateEditPermission';
  public static COMMANDS_PAYMENT_METHODS_TABLE_CREATE_EDIT = 'NewCommands\\AffiliateCrm\\AffiliatePaymentMethods\\CreateEditPermission';
  public static COMMANDS_DEEP_LINK_INSERT = 'NewCommands\\AffiliateCrm\\DeepLinks\\InsertPermission';

  public static SCOPES_VIEW_ONLY = 'Scopes\\ViewOnly';
}
